import { QueryClient } from '@tanstack/react-query';

/**
 * Polling curto: o painel de frota mostra heartbeat, e um heartbeat de
 * 30s atras ja e mentira (HEARTBEAT_TIMEOUT_S = 15).
 *
 * Quando doer, a troca certa e empurrar pelo WebSocket que ja existe na
 * 8080 em vez de encurtar o intervalo.
 */
export const INTERVALO_FROTA_MS = 5_000;
export const INTERVALO_OPERACAO_MS = 10_000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 3_000,
      retry: 2,
      refetchOnWindowFocus: true,
    },
  },
});
